import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import { nameSearchFilter } from "../../../utils/filter/filterFields";
import { ScholarshipsRecessesTable } from "./ScholarshipsRecessesTable";
import NoItemsToView from "components/layout/messageComponents/NoItemsToView";
import NoResultOnSearch from "components/layout/messageComponents/NoResultOnSearch";
import { useTranslation } from "react-i18next";
import InputFilter from "components/inputs/InputFilter";
import FilterContainer from "components/containers/FilterContainer";

export function ScholarshipsRecesses({ scholarshipRecesses }) {
  const [t] = useTranslation();

  const [text, setText] = useState("");
  const [notFound, setNotFound] = useState("");
  const [rows, setRows] = useState(scholarshipRecesses);

  useEffect(() => {
    let filteredRows = scholarshipRecesses;

    if (text !== "") {
      filteredRows = filteredRows.filter(item =>
        nameSearchFilter(item.collaboratorName, text)
      );
    }

    setRows(filteredRows);
  }, [scholarshipRecesses, text]);

  useEffect(() => {
    if (rows && rows.length === 0 && text !== "") {
      setNotFound(text);
    } else {
      setNotFound("");
    }
  }, [rows, text]);

  return (
    <div className="containerNewDesign">
      <Paper>
        <div className="cabecalho">{t("HR.scholarship").toUpperCase()}</div>

        <FilterContainer>
          <InputFilter
            filterValue={text}
            setFilter={setText}
            label={t("HR.scholarship")}
            maxLength={60}
          />
        </FilterContainer>

        <ScholarshipsRecessesTable
          rows={rows}
          attributes={[
            {
              name: "collaboratorName",
              columnText: t("GENERAL.collaborator"),
            },
            {
              name: "admissionDate",
              columnText: t("HR.admissionDate"),
            },
            {
              name: "",
              columnText: "",
            },
          ]}
        />
        {scholarshipRecesses && scholarshipRecesses.length === 0 && (
          <NoItemsToView
            messageLabel={"HR.noScholarshipsToBeShown"}
            messageDesc={"HR.scholarshipRecessListShouldBeListedHere"}
          />
        )}
        {notFound && <NoResultOnSearch notFound={notFound} />}
      </Paper>
    </div>
  );
}
